module.exports = __webpack_public_path__ + "static/media/admin-Icons-chat.2b874cbb.svg";